import { JObject } from "../../../../common/data/models";
import { buildFilterMetaToObject, buildSortParamsToString, PaginatedRequestParams, PaginatedResponse, Result } from "../../../../common/pagination";
import { endpoints } from "../../../../constants/endpoints";
import { tawreedHttpService } from "../../../../http";
import { TopUpTransaction } from "../../domain";
import { TopUpTransactionMapper } from "../mappers";

export class TopUpTransactionRepository {

    public search(request: PaginatedRequestParams): Promise<PaginatedResponse<TopUpTransaction>> {

        const params = {
            sort: request.sort ? buildSortParamsToString(request.sort) : undefined,
            page: request.page,
            size: request.size,
        };
        const data = { ...buildFilterMetaToObject(request.keyword, { ...request.filters }) };
        return tawreedHttpService.post<JObject, Result<JObject>>(endpoints.TOPUP_TRANSACTIONS_SEARCH, data, params, undefined, 'error')
            .then(res => {
                return {
                    ...res!,
                    data: { ...res!.data!, content: res!.data!.content.map(e => TopUpTransactionMapper.fromJson(e)) ?? [] },
                };
            });
    }

    /**
     * Get partner details by id
     * @param id
     */
    public async getDetails(id: number): Promise<TopUpTransaction> {
        return tawreedHttpService.post<number, JObject>(endpoints.TOPUP_TRANSACTIONS_GET_DETAILS, id, undefined, undefined, 'error').then(res => TopUpTransactionMapper.fromJson(res.data!));
    }
}